var _wrapNativeSuper = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _possibleConstructorReturn = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/inherits");

var _createClass = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/classCallCheck");

var TransactionOutput =
/**
 *
 * @param {number} outputIndex
 * @param {string} scriptPubKey
 * @param {string} balance
 * @param {string} address
 */
function TransactionOutput(outputIndex, scriptPubKey, balance, address) {
  "use strict";

  _classCallCheck(this, TransactionOutput);

  this.outputIndex = outputIndex;
  this.scriptPubKey = scriptPubKey;
  this.balance = balance;
  this.address = address;
};

var Contribution =
/**
 *
 * @param {string} txHash transaction hash
 * @param {TransactionOutput} output
 */
function Contribution(txHash, output) {
  "use strict";

  _classCallCheck(this, Contribution);

  this.txHash = txHash;
  this.output = output;
};

var Transaction =
/*#__PURE__*/
function () {
  "use strict";

  /**
   *
   * @param {string} txHash
   * @param {TransactionOutput[]} outputs
   */
  function Transaction(txHash, outputs) {
    _classCallCheck(this, Transaction);

    this.txHash = txHash;
    this.outputs = {};

    for (var i = 0; i < outputs.length; i += 1) {
      this.outputs[outputs[i].outputIndex] = outputs[i];
    }
  }
  /**
   *
   * @param {number} outputIndex
   * @returns {Contribution}
   */


  _createClass(Transaction, [{
    key: "getContribution",
    value: function getContribution(outputIndex) {
      return new Contribution(this.txHash, this.outputs[outputIndex]);
    }
    /**
     * @returns {Contribution[]}
     */

  }, {
    key: "getContributions",
    value: function getContributions() {
      var _this = this;

      return Object.keys(this.outputs).map(function (outputIndex) {
        return new Contribution(_this.txHash, _this.outputs[outputIndex]);
      });
    }
  }]);

  return Transaction;
}();

var Payment =
/**
 *
 * @param {string} to recipient address
 * @param {number} amount
 */
function Payment(to, amount) {
  "use strict";

  _classCallCheck(this, Payment);

  this.to = to;
  this.amount = amount;
};

var ActionLog =
/*#__PURE__*/
function () {
  "use strict";

  /**
   *
   * @param {string} verb
   * @param {string} object
   * @param {string|string[]} result
   * @param {ActionLog|ActionLog[]} subaction
   */
  function ActionLog(verb, object, result, subaction) {
    _classCallCheck(this, ActionLog);

    this.action = verb;
    this.object = object;
    this.log = "".concat(verb, " ").concat(object);
    this.result = Array.isArray(result) ? result : [result];
    this.subaction = Array.isArray(subaction) ? subaction : [subaction];
  }
  /**
   *
   * @returns {boolean}
   */


  _createClass(ActionLog, [{
    key: "hasResult",
    value: function hasResult() {
      return this.result[0] !== undefined && this.result[0] !== null;
    }
    /**
     *
     * @returns {boolean}
     */

  }, {
    key: "hasSubaction",
    value: function hasSubaction() {
      return this.subaction[0] !== undefined && this.subaction[0] !== null;
    }
  }]);

  return ActionLog;
}();

var AppendLog =
/*#__PURE__*/
function (_ActionLog) {
  "use strict";

  _inherits(AppendLog, _ActionLog);

  /**
   *
   * @param {string} appendage
   * @param {string} to
   * @param {string|string[]} result
   */
  function AppendLog(appendage, to, result) {
    var _this2;

    _classCallCheck(this, AppendLog);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(AppendLog).call(this, 'Append', "".concat(appendage, " to ").concat(to), result));
    _this2.from = appendage;
    _this2.to = to;
    return _this2;
  }

  return AppendLog;
}(ActionLog);

var AppendTransactionLog =
/*#__PURE__*/
function (_AppendLog) {
  "use strict";

  _inherits(AppendTransactionLog, _AppendLog);

  /**
   *
   * @param {string} appendage
   * @param {string} to
   * @param {string|string[]} result
   * @param {OrderedDict} transactionDict
   */
  function AppendTransactionLog(appendage, to, result, transactionDict) {
    var _this3;

    _classCallCheck(this, AppendTransactionLog);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(AppendTransactionLog).call(this, appendage, "transaction::".concat(to), "transaction::".concat(result)));
    _this3.transactionDict = transactionDict;
    return _this3;
  }

  return AppendTransactionLog;
}(AppendLog);

var ConversionLog =
/*#__PURE__*/
function (_ActionLog2) {
  "use strict";

  _inherits(ConversionLog, _ActionLog2);

  /**
   *
   * @param {string} from
   * @param {string} to
   * @param {string|string[]} result
   */
  function ConversionLog(from, to, result) {
    var _this4;

    _classCallCheck(this, ConversionLog);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ConversionLog).call(this, 'Convert', "".concat(from, " to ").concat(to), result));
    _this4.from = from;
    _this4.to = to;
    return _this4;
  }

  return ConversionLog;
}(ActionLog);

var ReplaceLog =
/*#__PURE__*/
function (_ActionLog3) {
  "use strict";

  _inherits(ReplaceLog, _ActionLog3);

  /**
   *
   * @param {string} original
   * @param {string} substitute
   * @param {string|string[]} result
   * @param {OrderedDict} transactionDict
   */
  function ReplaceLog(original, substitute, result, transactionDict) {
    var _this5;

    _classCallCheck(this, ReplaceLog);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ReplaceLog).call(this, 'Replace', "".concat(original, " with ").concat(substitute), result));
    _this5.transactionDict = transactionDict;
    return _this5;
  }

  return ReplaceLog;
}(ActionLog);

var OrderedDict =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * A javascript object/dict with ordered keys and array values
   * @param {strings[]} keys
   */
  function OrderedDict() {
    var _this6 = this;

    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, OrderedDict);

    this.keys = keys;
    this.vals = {};
    this.keys.forEach(function (key) {
      _this6.vals[key] = [];
    });
  }
  /**
   * Makes a best effort copy
   * @param {OrderedDict} oldDict
   * @returns {OrderedDict}
   */


  _createClass(OrderedDict, [{
    key: "pushTo",

    /**
     * Push an item to the array corresponding to the key
     * @param {string} key
     * @param {*} item
     */
    value: function pushTo(key, item) {
      if (!this.keys.includes(key)) {
        this.keys.push(key);
        this.vals[key] = [];
      }

      this.vals[key].push(item);
    }
    /**
     *
     * @param {string} key
     * @returns {*[]}
     */

  }, {
    key: "getValue",
    value: function getValue(key) {
      return this.vals[key];
    }
    /**
     *
     * @param {string} key
     * @param {*[]} value
     */

  }, {
    key: "setValue",
    value: function setValue(key, value) {
      this.vals[key] = value;
    }
    /**
     * Returns an ordered array of values
     * @returns {*[]}
     */

  }, {
    key: "getValues",
    value: function getValues() {
      var _this7 = this;

      var valueList = [];
      this.keys.forEach(function (key) {
        valueList.push(_this7.vals[key]);
      });
      return valueList;
    }
    /**
     * Returns an ordered array of objects containing key and value
     * Recursively decodes OrderedDicts
     * @returns {Objects[]}
     */

  }, {
    key: "getArray",
    value: function getArray() {
      var _this8 = this;

      var valueList = [];
      this.keys.forEach(function (key) {
        var values = _this8.vals[key] && _this8.vals[key].map(function (value) {
          var val = value instanceof OrderedDict ? value.getArray() : value;
          return val;
        });

        valueList.push({
          key: key,
          value: values
        });
      });
      return valueList;
    }
    /**
     *
     * @returns {string[]}
     */

  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keys;
    }
    /**
     *
     * @returns {number}
     */

  }, {
    key: "getLength",
    value: function getLength() {
      return this.keys.length;
    }
    /**
     *
     * @param {string} oldKey
     * @param {string} newKey
     * @param {*[]} newValue
     * @returns {boolean}
     */

  }, {
    key: "replace",
    value: function replace(oldKey, newKey, newValue) {
      if (!this.keys.includes(oldKey)) {
        return false;
      }

      for (var i = 0; i < this.getLength; i += 1) {
        if (this.key[i] === oldKey) {
          this.key[i] = newKey;
          break;
        }
      }

      delete this.vals[oldKey];
      this.vals[newKey] = newValue;
      return true;
    }
    /**
     *
     * @param {string} key
     */

  }, {
    key: "remove",
    value: function remove(key) {
      for (var i = 0; i < this.getLength(); i += 1) {
        if (this.keys[i] === key) {
          this.keys.splice(i, 1);
          break;
        }
      }

      delete this.vals[key];
    }
    /**
     * Concatenate all the values into a single string
     * @param {string} delimiter
     */

  }, {
    key: "join",
    value: function join() {
      var delimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ',';
      return this.getValues().join(delimiter);
    }
  }], [{
    key: "copy",
    value: function copy(oldDict) {
      var keys = oldDict.getKeys();
      var dict = new OrderedDict(keys);
      keys.forEach(function (key) {
        var value;

        if (Array.isArray(oldDict.getValue(key))) {
          value = oldDict.getValue(key).map(function (val) {
            if (val instanceof OrderedDict) {
              return OrderedDict.copy(val);
            }

            return JSON.parse(JSON.stringify(val));
          });
        } else {
          value = JSON.parse(JSON.stringify(oldDict.getValue(key)));
        }

        dict.setValue(key, value);
      });
      return dict;
    }
  }]);

  return OrderedDict;
}();

var InvalidInputError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(InvalidInputError, _Error);

  /**
   *
   * @param {string} message
   */
  function InvalidInputError(message) {
    var _this9;

    _classCallCheck(this, InvalidInputError);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidInputError).call(this, message));
    _this9.name = 'InvalidInputError';
    _this9.message = message;
    return _this9;
  }

  return InvalidInputError;
}(_wrapNativeSuper(Error));

module.exports = {
  TransactionOutput: TransactionOutput,
  Transaction: Transaction,
  Contribution: Contribution,
  Payment: Payment,
  ActionLog: ActionLog,
  ConversionLog: ConversionLog,
  AppendLog: AppendLog,
  AppendTransactionLog: AppendTransactionLog,
  ReplaceLog: ReplaceLog,
  OrderedDict: OrderedDict,
  InvalidInputError: InvalidInputError
};